/**
 * Feature flags — controlled via Vite env vars.
 * Set in Cloudflare Pages environment variables to enable.
 */
export const features = {
  /** Discover tab — disabled until there's enough user activity */
  discover: import.meta.env.VITE_DISCOVER_ENABLED === 'true',
};
